module.exports = __webpack_public_path__ + "3e8fd083366839c3281a8d2ba9613992.svg";